var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "national-base",
      class: { "no-sort": !(_vm.prize1 && _vm.prize1.rank) },
      style: `padding-top:${_vm.barHeight}px`,
    },
    [
      _c("van-nav-bar", {
        staticClass: "van-bar",
        attrs: { title: _vm.$t("lang.commonM.k111"), "left-arrow": "" },
        on: { "click-left": _vm.goPrevious },
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "left-nav",
                  attrs: {
                    src: require("@/assets/packageAssets/common/arrow02.png"),
                    alt: "",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("img", {
        staticClass: "bg-img",
        style: { "margin-top": `-${_vm.barHeight + 46}px` },
        attrs: { src: require("./images/rules-bg.png") },
      }),
      _c("div", { staticClass: "bg-block" }, [
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k230"))),
          ]),
          _vm.mexActStartTime && _vm.mexActEndTime
            ? _c("div", { staticClass: "item-txt" }, [
                _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k231")) + ": "),
                _c("br"),
                _c("i", { staticStyle: { color: "#ff9524" } }, [
                  _vm._v(
                    _vm._s(_vm.mexActStartTime) +
                      " - " +
                      _vm._s(_vm.mexActEndTime)
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k250"))),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k233"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k234"))),
          ]),
          _c(
            "div",
            { staticClass: "gift-num", staticStyle: { "margin-top": "16px" } },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Balloons.png"),
                    alt: "",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k304")) + " "),
              ]),
              _c("span", [
                _c("i", [_vm._v("1")]),
                _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "gift-num", staticStyle: { "margin-top": "16px" } },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Ring.png"),
                    alt: "",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k211")) + " "),
              ]),
              _c("span", [
                _c("i", [_vm._v("3")]),
                _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "gift-num", staticStyle: { "margin-top": "16px" } },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Rose.png"),
                    alt: "",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k212")) + " "),
              ]),
              _c("span", [
                _c("i", [_vm._v("5")]),
                _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "gift-num", staticStyle: { "margin-top": "16px" } },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Kiss.png"),
                    alt: "",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k305")) + " "),
              ]),
              _c("span", [
                _c("i", [_vm._v("15")]),
                _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "gift-num", staticStyle: { "margin-top": "16px" } },
            [
              _c("div", [
                _c("img", {
                  attrs: {
                    src: require("@/assets/packageAssets/common/Treasure.png"),
                    alt: "",
                  },
                }),
                _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k306")) + " "),
              ]),
              _c("span", [
                _c("i", [_vm._v("50")]),
                _vm._v(" " + _vm._s(_vm.$t("lang.valRuFe.points")) + " "),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k215"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k235"))),
          ]),
          _c(
            "div",
            {
              staticClass: "national-item",
              staticStyle: { "margin-top": "16px" },
            },
            [
              _c("div", { staticClass: "reward-num" }, [
                _vm._v("10 " + _vm._s(_vm.$t("lang.valRuFe.points"))),
              ]),
              _c("div", { staticClass: "reward-coins" }, [
                _vm._v(" 70 "),
                _c("img", {
                  staticClass: "coins-icon",
                  attrs: { src: _vm.getMatchImg("beans") },
                }),
              ]),
            ]
          ),
          _c("div", { staticClass: "national-item" }, [
            _c("div", { staticClass: "reward-num" }, [
              _vm._v("15 " + _vm._s(_vm.$t("lang.valRuFe.points"))),
            ]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 80 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("beans") },
              }),
            ]),
          ]),
          _c("div", { staticClass: "national-item" }, [
            _c("div", { staticClass: "reward-num" }, [
              _vm._v("20 " + _vm._s(_vm.$t("lang.valRuFe.points"))),
            ]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 100 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("beans") },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k238"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k239"))),
          ]),
          _c(
            "div",
            {
              staticClass: "national-item",
              staticStyle: { "margin-top": "16px" },
            },
            [
              _c("div", { staticClass: "reward-num" }, [_vm._v("No.1")]),
              _c("div", { staticClass: "reward-coins" }, [
                _vm._v(" 5000 "),
                _c("img", {
                  staticClass: "coins-icon",
                  attrs: { src: _vm.getMatchImg("beans") },
                }),
              ]),
            ]
          ),
          _c("div", { staticClass: "national-item" }, [
            _c("div", { staticClass: "reward-num" }, [_vm._v("No.2")]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 3000 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("beans") },
              }),
            ]),
          ]),
          _c("div", { staticClass: "national-item" }, [
            _c("div", { staticClass: "reward-num" }, [_vm._v("No.3")]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 2000 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("beans") },
              }),
            ]),
          ]),
          _c("div", { staticClass: "national-item" }, [
            _c("div", { staticClass: "reward-num" }, [_vm._v("No.4-10")]),
            _c("div", { staticClass: "reward-coins" }, [
              _vm._v(" 800 "),
              _c("img", {
                staticClass: "coins-icon",
                attrs: { src: _vm.getMatchImg("beans") },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k236"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k106"))),
          ]),
        ]),
        _c("div", { staticClass: "item-block" }, [
          _c("div", { staticClass: "item-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k237"))),
          ]),
          _c("div", { staticClass: "item-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k107"))),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }